import { render, staticRenderFns } from "./ServiceCategory.vue?vue&type=template&id=49469778"
import script from "./ServiceCategory.vue?vue&type=script&lang=js"
export * from "./ServiceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports